import { CreditCard } from 'lucide-react';
import { Button, CardHeader } from '@hue/design-system';
import { useEffect, useRef, type ReactNode } from 'react';
import { RequestAlert } from '../../app/data-view.js';

/// O quadro dos formulários dentro dos Pagamentos da venda: título, campos, erro e Voltar/ação.
export function FormFrame({
  title,
  children,
  error,
  saving,
  submitLabel,
  onCancel,
  onSubmit,
}: {
  title: string;
  children: ReactNode;
  error: string | undefined;
  saving: boolean;
  submitLabel: string;
  onCancel: () => void;
  onSubmit: () => void;
}) {
  const frame = useRef<HTMLElement>(null);
  /// No celular o formulário nasce abaixo da lista; ele vem até a vista para não parecer que o
  /// botão não fez nada.
  useEffect(() => {
    frame.current?.scrollIntoView?.({ block: 'nearest', behavior: 'smooth' });
  }, []);
  return (
    <section
      ref={frame}
      aria-label={title}
      className="grid gap-3 rounded-2xl border border-brand-500/50 bg-surface-card p-4"
    >
      <CardHeader title={title} level={3} icon={<CreditCard className="size-4" />} />
      {children}
      {error ? <RequestAlert message={error} /> : null}
      <div className="flex flex-wrap justify-end gap-2">
        <Button size="sm" variant="outline" onClick={onCancel} disabled={saving}>
          Voltar
        </Button>
        <Button size="sm" onClick={onSubmit} disabled={saving}>
          {submitLabel}
        </Button>
      </div>
    </section>
  );
}
